import { render } from "./WhyChooseUs.vue?vue&type=template&id=b6630298&ts=true"
import script from "./WhyChooseUs.vue?vue&type=script&lang=ts"
export * from "./WhyChooseUs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__